import { createFileRoute } from '@tanstack/react-router'
import { ForceChangePassword } from '@/features/auth/force-change-password'

export const Route = createFileRoute('/_authenticated/force-change-password')({
  component: ForceChangePassword,
})
